import 'css-chunksrc/client/scenes/project/resources/resource/styles.scss';export default {
  "resource": "_resource_1l4tj_1",
  "avatar": "_avatar_1l4tj_9",
  "name": "_name_1l4tj_14",
  "profession": "_profession_1l4tj_20"
};